// design/OpsOrgs.dc.html. GET /ops/orgs.
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, ApiFail } from "../api/client";
import type { ListResponse, OpsOrgOut } from "../api/types";
import { formatBytes } from "../library/format";
import { Notice } from "../components/ui";
import "../admin/admin.css";
import { Badge, Card } from "@grackle/ui";

export default function OpsOrgsPage() {
  const [orgs, setOrgs] = useState<OpsOrgOut[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api<ListResponse<OpsOrgOut>>("GET", "/ops/orgs")
      .then((res) => setOrgs(res.items))
      .catch((err) => setError(err instanceof ApiFail ? err.message : "Couldn't load orgs."));
  }, []);

  return (
    <>
      <header className="page-head">
        <div>
          <h1>Orgs</h1>
          <p>{orgs ? `${orgs.length} orgs` : "Loading…"}</p>
        </div>
      </header>

      {error ? <Notice tone="error">{error}</Notice> : null}

      {orgs ? (
        <Card size="flush" className="admin-table-card">
<table className="admin-table">
          <thead>
            <tr>
              <th className="gk-overline">Org</th>
              <th className="gk-overline num">Members</th>
              <th className="gk-overline num">Recordings</th>
              <th className="gk-overline num">Storage</th>
              <th className="gk-overline">Status</th>
            </tr>
          </thead>
          <tbody>
            {orgs.map((o) => (
              <tr key={o.id}>
                <td>
                  <Link to={`/ops/orgs/${o.id}`} className="admin-row-name">
                    {o.name}
                  </Link>
                  <div className="admin-row-sub">{o.slug}</div>
                </td>
                <td className="num">{o.member_count}</td>
                <td className="num">{o.grackle_count}</td>
                <td className="num">{formatBytes(o.storage_bytes)}</td>
                <td>
                  {o.suspended_at ? (
                    <Badge size="sm" tone="now" icon="warning-circle">Suspended</Badge>
                  ) : (
                    <span className="admin-row-sub">Active</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
</Card>
      ) : null}
    </>
  );
}
